import { FC, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { Star as StarIcon } from "@material-ui/icons";
import { CheckCircleRounded as CheckCircleRoundedIcon } from "@material-ui/icons";

import { ErrorMessage } from "components";
import { Button, Modal } from "components";
import { DEFAULT_ERROR_MESSAGE } from "services/constants";
import { createListingFeatureRequest } from "services/listings";
import theme from "theme";

const GetFeaturedStepTitle: FC = () => (
  <Typography component="div" gutterBottom>
    <Box
      fontSize={22}
      fontWeight={theme.typography.fontWeightMedium}
      textAlign="center"
      justifyItems="center"
      m={1}
    >
      <StarIcon style={{ color: theme.custom.palette.yellow.main }} />
      <label style={{ marginLeft: "4px", position: "relative", top: "3px" }}>
        Get Featured
      </label>
    </Box>
  </Typography>
);

const FeatureListingModalStepsTitles = [
  <GetFeaturedStepTitle key="get-featured-step-title" />,
  "Confirmed",
];
interface FeatureListingModalProps {
  listingId: number;
  onClose: () => void;
  onSuccessfulFeatureRequest: () => void;
}

const FeatureListingModal: FC<FeatureListingModalProps> = ({
  listingId,
  onClose,
  onSuccessfulFeatureRequest,
}) => {
  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await createListingFeatureRequest(listingId);
      onSuccessfulFeatureRequest();
      setIsLoading(false);
      setStep(1);
    } catch (e) {
      setError(e instanceof Error ? e.message : DEFAULT_ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title={FeatureListingModalStepsTitles[step]} open onClose={onClose}>
      {step === 0 && (
        <>
          <Typography component="div" gutterBottom>
            {error && (
              <Box my={2}>
                <ErrorMessage title="Request Failed" description={error} />
              </Box>
            )}

            <Box fontSize={13} textAlign="center" m={1}>
              Our{" "}
              <strong style={{ fontWeight: theme.typography.fontWeightMedium }}>
                Featured Listing
              </strong>{" "}
              section is now available to you!
            </Box>
            <Box fontSize={13} textAlign="center" m={1}>
              Your asset will be added to the list and featured once it’s your
              turn.
            </Box>
            <Box fontSize={13} textAlign="center" m={1}>
              Your asset will be featured for 7 days.
            </Box>
          </Typography>
          <Box m={2} textAlign="center">
            <Button
              id="btn-confirm-feature-listing-modal"
              fullWidth
              onClick={handleConfirm}
              disabled={isLoading}
              isLoading={isLoading}
              variant="contained"
            >
              Confirm Featured Listing
            </Button>
          </Box>
        </>
      )}
      {step === 1 && (
        <Typography component="div">
          <Box textAlign="center">
            <CheckCircleRoundedIcon
              style={{
                color: theme.custom.palette.purple.main,
                height: "85px",
                width: "85px",
              }}
            />
          </Box>
          <Box fontSize={15} textAlign="center" m={2} mt={4}>
            We’ll email you when your asset is featured.
          </Box>
        </Typography>
      )}
    </Modal>
  );
};

export default FeatureListingModal;
